import React from 'react';
import { SvgIcon } from '@mui/material';

function SuccessIcon() {
  return (
    <svg width="73" height="73" viewBox="0 0 73 73" fill="none">
      <circle cx="36.125" cy="36.125" r="36.125" fill="#BAD980" fillOpacity="0.6" />
      <circle cx="36.1247" cy="36.1257" r="28.028" fill="#5a8126" />
      <path
        // eslint-disable-next-line max-len
        d="M49.4852 25.9353C49.5936 26.0619 49.6796 26.2122 49.7383 26.3777C49.797 26.5432 49.8272 26.7206 49.8272 26.8998C49.8272 27.0789 49.797 27.2563 49.7383 27.4218C49.6796 27.5873 49.5936 27.7376 49.4852 27.8642L33.1851 46.9345C33.0769 47.0614 32.9484 47.162 32.807 47.2307C32.6655 47.2994 32.5139 47.3347 32.3607 47.3347C32.2076 47.3347 32.056 47.2994 31.9145 47.2307C31.7731 47.162 31.6446 47.0614 31.5364 46.9345L23.3864 37.3994C23.1677 37.1436 23.0449 36.7967 23.0449 36.4349C23.0449 36.0732 23.1677 35.7263 23.3864 35.4705C23.605 35.2147 23.9015 35.0711 24.2107 35.0711C24.5199 35.0711 24.8164 35.2147 25.035 35.4705L32.3607 44.044L47.8366 25.9353C47.9447 25.8085 48.0732 25.7078 48.2146 25.6392C48.3561 25.5705 48.5077 25.5352 48.6609 25.5352C48.814 25.5352 48.9657 25.5705 49.1071 25.6392C49.2486 25.7078 49.377 25.8085 49.4852 25.9353Z"
        fill="white"
      />
    </svg>
  );
}

export default SuccessIcon;
